import React, { useState, useEffect } from 'react'
import { Card } from 'components'
import Skeleton from 'react-loading-skeleton'
import styles from './list-card.module.scss'
const Text = require(`../../services/${process.env.REACT_APP_BRAND}/text/text.json`)

function ListCard({ links, filterByPrice, selectedGenders }) {
  const [canLoadCards, setCanLoadCards] = useState(false)
  const [priceSelectedFrom, setPriceSelectedFrom] = useState(false)
  const [priceSelectedTo, setPriceSelectedTo] = useState(false)

  useEffect(() => {
    if (filterByPrice) {
      setPriceSelectedFrom(filterByPrice.priceRangeSelected.from)
      setPriceSelectedTo(filterByPrice.priceRangeSelected.to)
    }
  }, [filterByPrice])

  useEffect(() => {
    const TIME_TO_LOADING = 1500
    setCanLoadCards(false)
    setTimeout(() => {
      setCanLoadCards(true)
    }, TIME_TO_LOADING)
  }, [links])

  function renderCard(card) {
    return (
      <Card image={card.image} link={card.url} filterByPrice={filterByPrice} buttonSeeMore={Text.cardButtonSeeMore}>
        {card.name}
      </Card>
    )
  }

  function renderTitles() {
    return (
      <>
        <h1>{Text.cardListTitle}</h1>
        <h3>{Text.cardListSubTitle}</h3>
      </>
    )
  }
  function renderEmptyMessage() {
    return (
      <>
        <h1>Ops!</h1>
        <h3>
          Não encontramos nenhum resultado. <br />
          Clique no banner acima e faça um novo teste
        </h3>
      </>
    )
  }

  function calculatePrices(link) {
    if (filterByPrice) {
      const linkTo = parseInt(link.linkPriceRange.to)
      const linkFrom = parseInt(link.linkPriceRange.from)
      const priceSelectedIsGreaterThanFrom =
        priceSelectedFrom > linkFrom || priceSelectedTo > linkFrom

      const priceSelectedIsSmallerThanTo =
        priceSelectedTo < linkTo || priceSelectedFrom < linkTo

      return priceSelectedIsGreaterThanFrom && priceSelectedIsSmallerThanTo
    }
    return true
  }

  function showCardsByGender(link) {
    if (!selectedGenders.length) return true;

    const selectedGendersId = selectedGenders.map(gender => gender.id);
    return selectedGendersId.includes(link.genderId);
  }

  function renderCards() {
    return (
      <div className={styles.listCard__item}>
        <ul>
          {links
            .filter(link => {
              return showCardsByGender(link)
            })
            .filter(link => {
              return calculatePrices(link)
            })
            .map((card, index) => (
              <li key={index}>
                {(canLoadCards && renderCard(card)) || (
                  <Skeleton height={'100%'} />
                )}
              </li>
            ))}
        </ul>
      </div>
    )
  }

  return (
    <div className={styles.listCard}>
      {links.length > 0 ? renderTitles() : renderEmptyMessage()}
      {links.length > 0 && renderCards()}
    </div>
  )
}

export { ListCard }
